import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { axiosPrivateInstance } from 'libs/axios';

import { GET_ALL_BUISNESS_TYPE } from 'utils/serviceUrls';
import { ERROR } from 'utils/constants';

import { useAppDispatch } from 'hooks/stateHooks';
import { setMessage, setNotificationType, setShowNotification } from 'slices/roleModuleSlice';

const useGetAllBusinessType = () => {
	const dispatch = useAppDispatch();
	const { t } = useTranslation('manufacturerModule');

	const [businessTypeResponseData, setBusinessTypeResponseData] = useState<any>([]);
	const [businessTypeLoading, setBusinessTypeLoading] = useState<boolean>(false);

	const ApiRespone = async () => {
		setBusinessTypeLoading(true);

		// eslint-disable-next-line no-unused-vars
		await axiosPrivateInstance
			.post(GET_ALL_BUISNESS_TYPE)
			.then((response: any) => {
				if (response?.output && response?.status) {
					setBusinessTypeResponseData(response?.output);
				} else {
					dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
					dispatch(setShowNotification(true));
					dispatch(setNotificationType(ERROR));
				}
			})
			.catch(() => {
				dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
				dispatch(setShowNotification(true));
				dispatch(setNotificationType(ERROR));
			})
			.finally(() => {
				setBusinessTypeLoading(false);
			});
	};

	useEffect(() => {
		ApiRespone();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		businessTypeResponseData,
		businessTypeLoading,
	};
};

export default useGetAllBusinessType;
